import React, { FunctionComponent, useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import summaryStyles from './SummaryStyles';
import SummaryTitle from '../summaryTitle/SummaryTitle';
import SectionStatesWrapper from '../../../../../../common/components/configuratorStates/SectionStatesWrapper';
import clsx from 'clsx';
import { CustomiseSections } from '../../../../../../common/enum/CustomiseSections';
import scrollInView, { ScrollInViewType } from '../../../../../../common/service/scrollInView';
import SummaryPricesContainer from '../summaryContent/summaryPrices/SummaryPricesContainer';
import SummaryLinksContainer from '../summaryLinks/SummaryLinksContainer';
import SummaryBaseContent from '../summaryContent/summaryBase/SummaryBaseContainer';
import SummaryAdditionalSelectionsContainer from '../summaryAdditionalSelections/SummaryAdditionalSelectionsContainer';
import customise from '../../../../../constants/customise';
import ScrollToWrapper from '../../../../presentational/ScrollToWrapper';
import SummaryFinance from '../summaryContent/summaryFinance/SummaryFinance';
import SummaryInsurance from '../summaryContent/summaryInsurance/SummaryInsurance';
import SummaryReservation from '../summaryRefundableAmount/SummaryReservation';
import usePlatformConfig from '../../../../../../common/react/usePlatformConfig';
import useCustomizeCarContext from '../../../../../hooks/useCustomizeCarContext';
import VehicleIdentificationNumber from '../summaryContent/stockSummary/vehicleIdentificationNumber/VehicleIdentificationNumber';
import { STOCK_SUMMARY_DISPLAY } from '../../../../../../../../common/constants/stockSummaryDisplay';

const SummaryContainer: FunctionComponent = () => {
  const styles = summaryStyles();
  const { loading, selectedCar, error } = useCustomizeCarContext();
  const selectedFeaturesId = selectedCar?.selectedFeatures.selected;
  const carImages = selectedCar?.images ?? [];

  const summaryName = customise.SUMMARY_ITEM.name;
  const [isExpanded, setIsExpanded] = useState(false);
  const {
    platformConfig: { showRefundableAmount, stockSummaryDisplay },
  } = usePlatformConfig();
  const { vin } = selectedCar?.stockInfo || {};

  useEffect(() => {
    const selectionsSection: HTMLElement = document.getElementById(CustomiseSections.SELECTIONS);

    if (isExpanded && selectionsSection) {
      scrollInView.scrollInView(selectionsSection, ScrollInViewType.TOP);
    }
  }, [isExpanded]);

  const showExtendedSummary = isExpanded && selectedCar && !!selectedFeaturesId?.length;

  return (
    <ScrollToWrapper target={summaryName} data-test="container:section:summary">
      <Grid container direction="column" wrap="nowrap" className={styles.summaryContainer}>
        <SummaryTitle setIsExpanded={setIsExpanded} isExpanded={isExpanded} />
        <SectionStatesWrapper error={error} loading={loading && !selectedCar}>
          <SummaryBaseContent imageUrl={carImages?.[0]?.url} />
          {selectedCar && (
            <>
              <SummaryPricesContainer />
              {stockSummaryDisplay === STOCK_SUMMARY_DISPLAY.VIN && !!vin && <VehicleIdentificationNumber />}
              <SummaryFinance />
              <SummaryInsurance />
              <SummaryLinksContainer />
              {showRefundableAmount && <SummaryReservation />}
            </>
          )}
        </SectionStatesWrapper>
      </Grid>
      {showExtendedSummary && (
        <Grid
          container
          direction="column"
          wrap="nowrap"
          className={clsx([styles.root, styles.expanded])}
          id="selections"
          data-test="container:summary:expanded_section"
        >
          <SummaryAdditionalSelectionsContainer />
        </Grid>
      )}
    </ScrollToWrapper>
  );
};

export default SummaryContainer;
